<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M22 11.6256V12.4996C21.9988 14.5482 21.3355 16.5415 20.1089 18.1823C18.8823 19.8231 17.1581 21.0234 15.1936 21.6043C13.2291 22.1851 11.1294 22.1154 9.20775 21.4054C7.2861 20.6955 5.64542 19.3834 4.53041 17.6648C3.4154 15.9462 2.8858 13.9132 3.02059 11.8691C3.15538 9.82491 3.94735 7.87909 5.27837 6.3218C6.60938 4.76451 8.40814 3.67919 10.4064 3.22772C12.4046 2.77624 14.4953 2.9828 16.3665 3.81658"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M22 4.99414L12.7692 13.9941L10 11.2968"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>
